// Resize only oversized photos before uploading (shared by /profile/disbursement and
// the recurring-expense create dialog — FileUpload.js itself is untouched). LINE/phone photos can be 3-9MB
// each; at full quality, 9 of them uploaded together can take 30-50s+ each
// on typical upload bandwidth. Downscaling the big ones cuts that down a lot
// while staying sharp enough to read (incl. future OCR).
const MAX_IMAGE_DIMENSION = 2500;
const IMAGE_QUALITY = 0.9;

const resizeImageFileIfNeeded = (file) =>
  new Promise((resolve) => {
    if (!file.type.startsWith('image/')) {
      resolve(file);
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      const { width, height } = img;
      if (width <= MAX_IMAGE_DIMENSION && height <= MAX_IMAGE_DIMENSION) {
        URL.revokeObjectURL(objectUrl);
        resolve(file);
        return;
      }

      let targetWidth = width;
      let targetHeight = height;
      if (width >= height) {
        targetWidth = MAX_IMAGE_DIMENSION;
        targetHeight = Math.round((height * MAX_IMAGE_DIMENSION) / width);
      } else {
        targetHeight = MAX_IMAGE_DIMENSION;
        targetWidth = Math.round((width * MAX_IMAGE_DIMENSION) / height);
      }

      const canvas = document.createElement('canvas');
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      canvas.getContext('2d').drawImage(img, 0, 0, targetWidth, targetHeight);
      canvas.toBlob(
        (blob) => {
          URL.revokeObjectURL(objectUrl);
          resolve(blob ? new File([blob], file.name, { type: 'image/jpeg' }) : file);
        },
        'image/jpeg',
        IMAGE_QUALITY,
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(file); // decode failed for some reason — upload the original untouched
    };
    img.src = objectUrl;
  });

export default resizeImageFileIfNeeded;
